// extracted by mini-css-extract-plugin
module.exports = {"root":"Counter_root__9Vfp1","output":"Counter_output__dZ9VH","icon":"Counter_icon__uza8s"};